import React from 'react';

const COLOR_CLASS_BY_STATUS = {
  green: 'bg-green-500',
  amber: 'bg-amber-400',
  red: 'bg-red-500',
  grey: 'bg-gray-300',
};

function RAGCircle({ statusBand, statusLabel, averagePercent, heading }) {
  const band = COLOR_CLASS_BY_STATUS[statusBand] ? statusBand : 'grey';
  const label = band === 'grey' ? 'Not attempted' : statusLabel;
  const percentText =
    band === 'grey' || averagePercent === null || averagePercent === undefined
      ? '--'
      : `${(Math.round(averagePercent * 10) / 10).toFixed(1)}%`;

  return (
    <div className="flex flex-col items-center gap-1 transition-transform duration-200 group-hover:-translate-y-0.5 motion-reduce:transform-none">
      <span className="text-xs text-gray-700">{label}</span>
      <div
        className={`relative h-10 w-10 rounded-full ${COLOR_CLASS_BY_STATUS[band]} text-white text-[10px] font-semibold flex items-center justify-center transition-all duration-200 ease-out group-hover:scale-105 group-hover:shadow-[0_6px_16px_-10px_rgba(0,0,0,0.30)] motion-reduce:transform-none`}
      >
        <span className="pointer-events-none absolute inset-0 rounded-full ring-0 ring-white/40 transition-all duration-200 group-hover:ring-1" />
        {percentText}
      </div>
      {heading && <span className="text-xs text-gray-500">{heading}</span>}
    </div>
  );
}

export default RAGCircle;
